
import { lazy } from 'react'
import SubDepartment from '../components/Subdepartments'
import AdminPage from '../components/UserAdminComponnets/AdminPage'
import UserPostManagement from '../components/UserAdminComponnets/UserPostManagement'
import UserManagementPage from '../components/UsersRoleManagement'
import Discussions from '../components/DiscussionForum/Discussion'
import PostManagement from '../components/departments/PostManagement'
import ProjectManagement from '../components/ProjectManagement/ProjectManagement'
const Dashboard = lazy(() => import('../pages/protected/Dashboard'))
const Welcome = lazy(() => import('../pages/protected/Welcome'))
const Page404 = lazy(() => import('../pages/protected/404'))
const Blank = lazy(() => import('../pages/protected/Blank'))
const AnalyticsDashboard = lazy(() => import('../pages/protected/AnalyticsDashboard'))
const ProfileSettings = lazy(() => import('../pages/protected/ProfileSettings'))


const routes = [
  {
    path: '/dashboard', 
    component: Dashboard, 
  },
  {
    path: '/welcome',
    component: Welcome, 
  },
  {
    path: '/Subdepartments',
    component: SubDepartment,
  },
  {
    path: '/Admin',
    component: AdminPage,
  },
  {
    path: '/User',
    component: UserManagementPage,
  },
  {
    path: '/UserPostManagement',
    component: UserPostManagement,
  },
  {
    path: '/PostManagement',
    component: PostManagement,
  },
  {
    path: '/discussion',
    component: Discussions,
  },
  {
    path: '/project-management',
    component: ProjectManagement,
  },
  {
    path: '/settings-profile',
    component: ProfileSettings,
  },
  {
    path: '/AnalyticsDashboard',
    component: AnalyticsDashboard,
  },
  {
    path: '/404',
    component: Page404,
  },
  {
    path: '/blank',
    component: Blank,
  },
]

export default routes
